import './record-search-screen.scss'

import { AuditCampaign, AuditCampaignDataStore, auditCampaignSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchHeader } from '@skinsoft/search';
import Component from 'vue-class-component';
import { RecordFeaturedList } from '../record-featured-list';

import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { AuditCampaignFeatured, toCampaignFeatured$ } from '@skinsoft/entity-ui';
import { AddItemModal, CollaboratorView, CollapsibleHeader } from '@skinsoft/ui';
import _ from 'lodash';
import { first, switchMap } from 'rxjs/operators';
import { Watch } from 'vue-property-decorator';
import { OPEN_ADD_ITEM_MODAL, PUSH_SYNCHRO_PERFORMED } from '../../../../busTopics';
import { Routes } from '../../../../router';
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';

declare const RECORD_SORTING_ENTITY_FIELDS: any[];

@Component({
    components: {
        sAddItemModal: AddItemModal,
        sCollaboratorView: CollaboratorView,
        sCollapsibleHeader: CollapsibleHeader,
        sRecordFeaturedList: RecordFeaturedList,
        sSearchHeader: SearchHeader,
    },
    props: ['titleI18NKey'],
    template: require('./record-search-screen.html')
})
export class RecordSearchScreen extends ReactiveVue {

    private get itemsIdsToExclude() {
        return auditCampaignSelectors.linkableItems(this.campaign)
    }

    public titleI18NKey: string;

    public $refs: {
        addItemModal: AddItemModal;
    }

    private campaignId: string = "";
    private campaign: AuditCampaign = null as any;
    private campaignFeatured: AuditCampaignFeatured = null as any;
    private nbRecords: string = "";
    private targetRouteName: string = "/record"
    private linkedRecordsIds: string[] = [];
    private ready: boolean = false;

    // Icons
    private arrowIcon = faCaretUp;

    private $auditCampaignDataStore: AuditCampaignDataStore;

    private subscribe() {
        this.campaignId = this.$route.params.campaignId
        const locale = this.$i18n.locale;

        if (this.campaignId) {
            this.subscribeTo(this.$auditCampaignDataStore.fetchOne(this.campaignId)
                .pipe(
                    first(),// To avoid double emissions due to cache merging
                    switchMap(
                        campaign => {
                            this.campaign = campaign;
                            this.linkedRecordsIds = auditCampaignSelectors.auditRecords(campaign);
                            return toCampaignFeatured$(campaign, locale);
                        }
                    )),
                campaignFeatured => {
                    this.campaignFeatured = campaignFeatured;
                    this.ready = true;
                }
                ,
                'campaign-subscription')
        }

        this.$on('nb-fetched-reports-topic', (message) => {
            this.nbRecords = this.$t('listReportScreen.nbResults', { nbResults: message.nbRecords }) as string;
        })
        this.subscribeToBus(OPEN_ADD_ITEM_MODAL, this.openAddItemModal, 'on-open-add-item-modal')
        this.subscribeToBus(PUSH_SYNCHRO_PERFORMED, this.initialize, 'on-push-synchro-performed')
    }

    private unsubscribe() {
        this.unsubscribeFrom('campaign-subscription')
        this.unsubscribeFrom('on-open-add-item-modal')
        this.unsubscribeFrom('on-push-synchro-performed')
    }

    private openAddItemModal() {
        if (this.$refs.addItemModal) {
            this.$refs.addItemModal.open()
        }
    }

    private onAddedItemSelected(item) {
        const oldRecordslist = _.cloneDeep(auditCampaignSelectors.auditRecords(this.campaign));
        this.$auditCampaignDataStore.addItem(
            this.campaign,
            item.id,
            item.type
        ).then(
            response => {
                this.unsubscribeFrom('campaign-subscription')
                const newRecordslist = auditCampaignSelectors.auditRecords(response);

                // testing last record first id for performance purposes
                let recordId = newRecordslist[newRecordslist.length - 1];
                if (oldRecordslist.includes(recordId)) {
                    // fetching right id by difference between old and new array (if needed)
                    const recordsDiff = newRecordslist.filter(r => !oldRecordslist.includes(r))
                    if (recordsDiff && recordsDiff.length > 0) {
                        recordId = recordsDiff[0]
                        this.openEditRecordScreen(recordId)
                    }
                } else {
                    this.openEditRecordScreen(recordId)
                }
            }
        )
    }

    private openEditRecordScreen(recordId: string) {
        this.$refs.addItemModal.close()
        this.emitOnBus(TOGGLE_MENU_TOPIC);
        this.$router.push({ name: Routes.RECORD, params: { campaignId: this.$route.params.campaignId, recordId } })
    }

    private initialize() {
        this.ready = false;
        this.unsubscribe();
        this.subscribe();
    }

    @Watch('route', { immediate: true, deep: true })
    private onRouteChange() {
        this.initialize();
    }

}